import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import LocationInterface from '@solvhealth/types/interfaces/Location';
import { FETCH_LOCATION_SET_LOCATIONS } from '../../../constants/index';
import { setEmptyLocation } from '../../../actions/location';
import { DataLock } from '../../../core/util/dataLock';
import useSelectGetLocationId from './useSelectGetLocationId';
import useSelectFetchAccountAppointments from './useSelectFetchAccountAppointments';
import { useSolvSelector } from '~/reducers';

const dataLock = new DataLock('');

export default (userProfileId: any): { isLoading: boolean; location: LocationInterface } => {
  const dispatch = useDispatch();
  const locationId = useSelectGetLocationId(userProfileId);
  const { pastAppointments, upcomingAppointments } =
    useSelectFetchAccountAppointments(userProfileId);
  const mostRecentPastLocation = useSolvSelector(
    (state) => state.locations.results[locationId] || null
  );

  const isLoading = useSolvSelector(
    (state) => !!(state.account.accountSummaryLoading || state.account.accountAppointmentsFetching)
  );

  useEffect(() => {
    if ((!isLoading && dataLock.isSame(userProfileId)) || !isEmpty(mostRecentPastLocation)) {
      return;
    }
    dataLock.updateValue(userProfileId);

    if (locationId && !isEmpty(upcomingAppointments) && !isEmpty(pastAppointments))
      dispatch({
        type: FETCH_LOCATION_SET_LOCATIONS,
        locationId,
      });
    else {
      dispatch(setEmptyLocation());
    }
  }, [
    dispatch,
    locationId,
    mostRecentPastLocation,
    pastAppointments,
    upcomingAppointments,
    userProfileId,
    isLoading,
  ]);

  return {
    isLoading,
    location: mostRecentPastLocation || {},
  };
};
